import React from 'react';

import { AssessmentTestContext } from '../../contexts/assessment-test';
import {
  getAssessmentSecondsSpent,
  isSelfAssessmentStep,
} from '../../contexts/assessment-test/helpers';
import { useTimeTicker } from '../../hooks/assessment-test/use-time-ticker';
import { useActiveTestStep } from '../../hooks/assessment-test/use-active-step';

export const TEST_EXPIRATION_WARNING_SECONDS = 40 * 60;
export const TEST_EXPIRATION_WARNING_READABLE = '40 minutes';

export const TEST_EXPIRATION_SECONDS = 60 * 60;
export const TEST_EXPIRATION_READABLE = '1 hour';

export const STEP_EXPIRATION_WARNING_SECONDS = 5 * 60;
export const STEP_EXPIRATION_WARNING_READABLE = '5 minutes';

export default function TestTimeoutHandler() {
  const [state, dispatch] = React.useContext(AssessmentTestContext);
  const now = useTimeTicker(1000);
  const { stepId } = useActiveTestStep();
  const secondsSpent = getAssessmentSecondsSpent(state, now);

  React.useEffect(() => {
    if (state.screen.type !== 'STEP') {
      return;
    }
    // Don't trigger timeout during self-assessment step
    const currentStep = state.steps.find((s) => s.id === stepId);
    if (currentStep && isSelfAssessmentStep(currentStep)) {
      return;
    }
    if (secondsSpent > TEST_EXPIRATION_SECONDS) {
      dispatch({ type: 'TIMEOUT_TEST', timestamp: new Date() });
    }
  }, [secondsSpent, dispatch, state.screen.type, stepId, state.steps]);

  return null;
}
